// JSON-LD helper functions for structured data
export const organizationJsonLd = (): Record<string, unknown> => ({
  "@context": "https://schema.org",
  "@type": "Organization",
  name: "Poremat",
  url: "https://poremat.com",
  logo: "https://poremat.com/logo.png",
  description: "Advanced MOF-based hydrogen storage solutions",
  sameAs: [
    "https://linkedin.com/company/poremat",
    "https://twitter.com/poremat",
  ],
})

export const productJsonLd = (product: {
  name: string
  description: string
  image?: string
}): Record<string, unknown> => ({
  "@context": "https://schema.org",
  "@type": "Product",
  name: product.name,
  description: product.description,
  image: product.image,
  brand: {
    "@type": "Brand",
    name: "Poremat",
  },
})

export const articleJsonLd = (article: {
  title: string
  description: string
  publishedAt: string
  image?: string
}): Record<string, unknown> => ({
  "@context": "https://schema.org",
  "@type": "Article",
  headline: article.title,
  description: article.description,
  datePublished: article.publishedAt,
  image: article.image,
  author: {
    "@type": "Organization",
    name: "Poremat",
  },
  publisher: {
    "@type": "Organization",
    name: "Poremat",
    logo: {
      "@type": "ImageObject",
      url: "https://poremat.com/logo.png",
    },
  },
})
